import React, { useEffect, useState } from "react";
import axios from "axios";
import StageSelect from "../../Components/common/commonDropdownWithId";
import { downloadReport } from "../../Utils/APIs/downloadExcelAPI";
import { IoLogoWhatsapp } from "react-icons/io";
import { showData } from "../../Utils/APIs/commonShowAPI";
import { reportAPI } from "../../Utils/APIs/reportAPI";
import SingleSelect from "../../Components/common/dropDown/SingleSelect";
const Index = () => {
  const role = localStorage.getItem("role");
  console.log("Role", role);
  const [fieldSalesList, setFieldSalesList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedStage, setSelectedStage] = useState("");
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [complaintFileToDownload, setComplaintFileToDownload] = useState([]);
  const [errorList, setErrorList] = useState([]);
  const [error, setError] = useState("");
  // Additional state variables

  useEffect(() => {
    (async function fetchFieldSalesData() {
      try {
        setIsLoading(true);
        const sendRequest = await axios.get(
          `http://88.222.214.93:5000/service-team/all-service-persons`
        );
        setFieldSalesList(sendRequest.data.data);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);

  useEffect(() => {
    (async function fetchServiceData() {
      try {
        setIsLoading(true);
        const response = await axios.get(
          `http://88.222.214.93:5000/service-team/all-service-data`
        );
        setComplaintFileToDownload(response.data.data);
      } catch (error) {
        console.log("Error fetching service data:", error);
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);

  const onClickDownloadExcel = () => {
    console.log("Error", error);
    const api = `/admin/reportDownload?stageId=${selectedStage}&assignEmployee=${selectedEmployee}&startDate=${startDate}&endDate=${endDate}&error=${error}`;
    downloadReport(api);
  };
  useEffect(() => {
    async function fetchData() {
      await showData("common/showAllErrorList", setErrorList);
    }
    fetchData();
  }, []);
  const handleButtonClick = async (API) => {
    await reportAPI(API);
  };
  // Installer report
  const [formData, setFormData] = useState({
    installerId: "",
  });
  const [installerList, setInstallerList] = useState([]);
  const fetchInstallerList = async () => {
    await showData("installer/getInstallerList", setInstallerList);
  };
  useEffect(() => {
    fetchInstallerList();
  }, []);
  const handleChangeInput = (e) => {
    console.log("working...");
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const [status, setStatus] = useState("");
  const onClickDownloadInstallerExcel = () => {
    console.log("Error", error);
    const api = `/installer/installerReportDownload?startDate=${startDate}&endDate=${endDate}&installerId=${formData.installerId}&status=${status}`;
    downloadReport(api);
  };
  const installerStatusList = [
    { _id: "Pending", name: "Pending" },
    { _id: "Approved By Filing", name: "Approved By Filing" },
    { _id: "Reject By Filing", name: "Reject By Filing" },
    { _id: "Approved By Admin", name: "Approved By Admin" },
    { _id: "Reject By Admin", name: "Reject By Admin" },
    { _id: "Awaiting Payment", name: "Awaiting Payment" },
    { _id: "Paid", name: "Paid" },
    { _id: "Reject By Account", name: "Reject By Account" },
  ];
  useEffect(() => {
    console.log("Status changed:", status);
  }, [status]);
  return (
    <div className="h-full overflow-auto">
      <div className="text-center">
        <h1 className="text-3xl font-semibold tracking-widest text-center p-2 bg-gray-800 text-gray-100">
          C<span className="text-lg">OMPLAIN</span> D
          <span className="text-lg">ATA</span>
        </h1>
      </div>
      <div className="grid gap-3 m-6 md:grid-cols-5 items-center">
        <div>
          <label
            htmlFor="Stage_Name"
            className="block mb-2 text-sm font-medium text-gray-900"
          >
            STAGE<span className="text-red-500 relative h-3">*</span>
          </label>
          <StageSelect
            Api_path={"common/showStage"}
            value={selectedStage}
            onChange={(stage) => setSelectedStage(stage)}
            label={"Stage"}
          />
        </div>
        <div>
          <label
            htmlFor="startDate"
            className="block mb-2 text-sm font-medium text-gray-900"
          >
            Field Service<span className="text-red-500 relative h-3">*</span>
          </label>
          <select
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:border-gray-600 dark:placeholder-gray-400 dark:focus:ring-blue-500 dark:focus:border-blue-500"
            id="state-select"
            value={selectedEmployee}
            onChange={(e) => setSelectedEmployee(e.target.value)}
          >
            <option value="">-- Select Field Sales --</option>
            {fieldSalesList.map(({ _id, name }) => (
              <option key={_id} value={_id}>
                {name}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label
            htmlFor="startDate"
            className="block mb-2 text-sm font-medium text-gray-900"
          >
            Problem List
          </label>
          <select
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:border-gray-600 dark:placeholder-gray-400 dark:focus:ring-blue-500 dark:focus:border-blue-500"
            id="state-select"
            value={error}
            onChange={(e) => setError(e.target.value)}
          >
            <option value="">-- Select Problem Types --</option>
            {errorList.map((name) => (
              <option key={name} value={name}>
                {name}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label
            htmlFor="startDate"
            className="block mb-2 text-sm font-medium text-gray-900"
          >
            Start Date<span className="text-red-500 relative h-3">*</span>
          </label>
          <input
            type="date"
            id="startDate"
            onChange={(e) => {
              setStartDate(e.target.value);
            }}
            value={startDate}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5  "
            placeholder="Saral Id"
            required
          />
        </div>
        <div>
          <label
            htmlFor="endDate"
            className="block mb-2 text-sm font-medium text-gray-900 "
          >
            End Date<span className="text-red-500 relative h-3">*</span>
          </label>
          <input
            type="date"
            id="endDate"
            onChange={(e) => {
              setEndDate(e.target.value);
            }}
            value={endDate}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5  "
            placeholder="Saral Id"
            required
          />
        </div>
        <div>
          <label className="block mb-2 text-sm font-medium ">
            Download Excel
          </label>
          <button
            onClick={onClickDownloadExcel}
            type="button"
            className="text-gray-900 text-sm rounded-sm block w-full p-2.5  bg-yellow-300 hover:bg-yellow-500 font-medium"
          >
            Download
          </button>
        </div>
      </div>

      {role === "Super Admin" && (
        <>
          <div>
            <div className="text-center">
              <h1 className="text-3xl font-semibold tracking-widest text-center p-2 bg-gray-800 text-gray-100">
                F<span className="text-lg">ARMER</span> D
                <span className="text-lg">OWNLOAD</span>
              </h1>
            </div>
            <div className="flex flex-wrap gap-4 mt-4 px-4 w-full justify-center md:justify-start"></div>
          </div>
          <div className="mt-20">
            <div className="text-center">
              <h1 className="text-3xl font-semibold tracking-widest text-center p-2 bg-gray-800 text-gray-100">
                D<span className="text-lg">ownload</span> R
                <span className="text-lg">eport</span>
              </h1>
            </div>
            <div className="flex flex-wrap gap-4 mt-4 px-4 w-full justify-evenly md:justify-start">
              <button
                type="button"
                onClick={() =>
                  handleButtonClick(
                    `${process.env.REACT_APP_API_URL}/report/dailyEmpActivityReport`
                  )
                }
                className="text-gray-900 text-sm w-40 rounded-md p-2.5 bg-yellow-400 hover:bg-yellow-500 font-medium"
              >
                Upload Daily
              </button>
              <button
                type="button"
                onClick={() =>
                  handleButtonClick(
                    `${process.env.REACT_APP_API_URL}/admin/complaintReport`
                  )
                }
                className="text-gray-900 text-sm w-40 rounded-md p-2.5 bg-red-400 hover:bg-red-500 font-medium"
              >
                Overall Stage
              </button>
              <button
                type="button"
                onClick={() =>
                  handleButtonClick(
                    `${process.env.REACT_APP_API_URL}/admin/distanceReport`
                  )
                }
                className="text-gray-900 text-sm w-40 rounded-md p-2.5 bg-pink-400 hover:bg-pink-500 font-medium"
              >
                Distance
              </button>
              <button
                type="button"
                onClick={() =>
                  handleButtonClick(
                    `${process.env.REACT_APP_API_URL}/admin/fieldEmpWorkReport`
                  )
                }
                className="text-gray-900 text-sm w-40 rounded-md p-2.5 bg-blue-400 hover:bg-blue-500 font-medium"
              >
                Field Employee
              </button>
              <button
                type="button"
                onClick={() =>
                  handleButtonClick(
                    `${process.env.REACT_APP_API_URL}/insurance/reportDownload`
                  )
                }
                className="text-gray-900 text-sm w-40 rounded-md p-2.5 bg-blue-400 hover:bg-blue-500 font-medium"
              >
                Insurance Report
              </button>
              <button
                type="button"
                onClick={() =>
                  handleButtonClick(
                    `${process.env.REACT_APP_API_URL}/external/generateServicePersonItemsReport`
                  )
                }
                className="text-gray-900 text-sm w-40 rounded-md p-2.5 bg-orange-400 hover:bg-orange-500 font-medium"
              >
                Service Person Item
              </button>
              <button
                type="button"
                onClick={() =>
                  handleButtonClick(
                    `${process.env.REACT_APP_API_URL}/external/generateIncomingReport`
                  )
                }
                className="text-gray-900 text-sm w-40 rounded-md p-2.5 bg-indigo-400 hover:bg-indigo-500 font-medium"
              >
                Incoming Item
              </button>
              <button
                type="button"
                onClick={() =>
                  handleButtonClick(
                    `${process.env.REACT_APP_API_URL}/external/generateOutgoingReport`
                  )
                }
                className="text-gray-900 text-sm w-40 rounded-md p-2.5 bg-lime-400 hover:bg-lime-500 font-medium"
              >
                Outgoing Item
              </button>
              {/* <button type="button" onClick={() => handleButtonClick(`${process.env.REACT_APP_API_URL}/external/`)} className="text-gray-900 text-sm w-40 rounded-md p-2.5 bg-cyan-400 hover:bg-cyan-500  font-medium">Repair/Reject Item</button> */}
              <button
                type="button"
                onClick={() =>
                  handleButtonClick(
                    `${process.env.REACT_APP_API_URL}/external/generateBhiwaniDailyReport`
                  )
                }
                className="text-gray-900 text-sm w-40 rounded-md p-2.5 bg-slate-400 hover:bg-slate-500 font-medium"
              >
                Bhiwani Daily Report
              </button>
              <button
                type="button"
                onClick={() =>
                  handleButtonClick(
                    `${process.env.REACT_APP_API_URL}/external/generateBhiwaniDailyInOutReport`
                  )
                }
                className="text-gray-900 text-sm w-auto rounded-md p-2.5 bg-amber-400 hover:bg-amber-500 font-medium text-nowrap"
              >
                Bhiwani In-Out Daily Report
              </button>
              <button
                type="button"
                onClick={() =>
                  handleButtonClick(
                    `${process.env.REACT_APP_API_URL}/external/generateOverallServiceRecord`
                  )
                }
                className="text-gray-900 text-sm w-auto rounded-md p-2.5 bg-rose-400 hover:bg-rose-500 font-medium text-nowrap"
              >
                Bhiwani Overall Service Report
              </button>
              <button
                type="button"
                onClick={() =>
                  handleButtonClick(
                    `${process.env.REACT_APP_API_URL}/external/generateRawMaterialStock`
                  )
                }
                className="text-gray-900 text-sm w-auto rounded-md p-2.5 bg-lime-400 hover:bg-lime-500 font-medium text-nowrap"
              >
                Raw Material Stock
              </button>
              <button
                type="button"
                onClick={() =>
                  handleButtonClick(
                    `${process.env.REACT_APP_API_URL}/external/generateDailyServiceRecord`
                  )
                }
                className="text-gray-900 text-sm w-auto rounded-md p-2.5 bg-fuchsia-400 hover:bg-fuchsia-500 font-medium text-nowrap"
              >
                Daily Service Record
              </button>

              <button
                type="button"
                onClick={() =>
                  handleButtonClick(
                    `${process.env.REACT_APP_API_URL}/report/fieldEmployeeComplaintPercentageReport`
                  )
                }
                className="text-gray-900 text-sm w-72 rounded-md p-2.5 bg-cyan-400 hover:bg-cyan-500 text-nowrap font-medium"
              >
                Field Employee Complaint % Report
              </button>
              <button
                type="button"
                onClick={() =>
                  handleButtonClick(
                    `${process.env.REACT_APP_API_URL}/admin/reportSendOnWhatsApp`
                  )
                }
                className="text-green-500 text-lg rounded-md p-2 border-2 border-green-500 font-medium"
              >
                <IoLogoWhatsapp />
              </button>
              <button
                type="button"
                onClick={() =>
                  handleButtonClick(
                    `${process.env.REACT_APP_API_URL}/admin/deleteFiles`
                  )
                }
                className="text-white text-sm w-40 rounded-md p-2.5 bg-gray-800 hover:bg-gray-950 font-medium"
              >
                Remove Web Reports
              </button>
              <button
                type="button"
                onClick={() =>
                  handleButtonClick(
                    `${process.env.REACT_APP_API_URL}/external/deleteAppReports`
                  )
                }
                className="text-white text-sm w-40 rounded-md p-2.5 bg-gray-800 hover:bg-gray-950 font-medium"
              >
                Remove App Reports
              </button>
            </div>
          </div>
        </>
      )}
      <div className="text-center pt-6">
        <h1 className="text-3xl font-semibold tracking-widest text-center p-2 bg-gray-800 text-gray-100">
          I<span className="text-lg">NSTALLER</span> D
          <span className="text-lg">ATA</span>
        </h1>
      </div>
      <div>
        <div className="grid gap-3 m-6 md:grid-cols-5 items-center">
          <div>
            <label
              htmlFor="state"
              className="block mb-2 text-sm font-medium text-gray-900 "
            >
              Select Installer
              <span className="text-red-500 fixed h-3">*</span>
            </label>
            <select
              name="installerId"
              onChange={handleChangeInput}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:focus:ring-blue-500 dark:focus:border-blue-500"
            >
              {formData?.installerId === "" ? (
                <option>Select Installer</option>
              ) : (
                <option disabled>Select State</option>
              )}
              {installerList?.map(({ name, _id }, index) => (
                <option key={index} value={_id}>
                  {name}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label
              htmlFor="startDate"
              className="block mb-2 text-sm font-medium text-gray-900"
            >
              Start Date<span className="text-red-500 relative h-3">*</span>
            </label>
            <input
              type="date"
              id="startDate"
              onChange={(e) => {
                setStartDate(e.target.value);
              }}
              value={startDate}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5"
              placeholder="Saral Id"
              required
            />
          </div>
          <div>
            <label
              htmlFor="endDate"
              className="block mb-2 text-sm font-medium text-gray-900 "
            >
              End Date<span className="text-red-500 relative h-3">*</span>
            </label>
            <input
              type="date"
              id="endDate"
              onChange={(e) => {
                setEndDate(e.target.value);
              }}
              value={endDate}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5"
              placeholder="Saral Id"
              required
            />
          </div>
          <div>
              <SingleSelect
                label={"Status"}
                required={true}
                selectedField={status}
                list={installerStatusList}
                setterFunction={setStatus}
                />
          </div>
          <div>
            <label className="block mb-2 text-sm font-medium ">
              Download Report
            </label>
            <button
              onClick={onClickDownloadInstallerExcel}
              type="button"
              className="text-gray-900 text-sm rounded-sm block w-full p-2.5  bg-yellow-300 hover:bg-yellow-500 font-medium"
            >
              Download
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
